import React, {Component} from 'react';
import _ from 'lodash';
import * as HTML_RENDITION from '../utils/general/general';
import DomTemplate from './domTemplate';
import BbryAccordionsTemplate from './bbryAccordionsTemplate';
import StyleTransfrom from '../utils/general/styleTransform';
import shortid from 'shortid';
import $ from 'jquery';

interface ICitiListTemplateProps {
    type: string;
    source: any;
    mainSource: any;
    elementParent: string;
    showOriginalText?: boolean;
}

interface ICitiListTemplateStatus {
    finalElement: Array<object>;
}

class CitiListTemplate extends Component<ICitiListTemplateProps, ICitiListTemplateStatus> {

    public allListElements: Array<object>;
    public allListElementStyle: string;
    public allListElementClass: string;
    public allListElementStart: string;
    public levelClass: string;
    public templateElement: Array<object>;

    constructor(props: ICitiListTemplateProps) {
        super(props);
        this.allListElements = [];
        this.allListElementStyle = "";
        this.allListElementClass = "";
        this.allListElementStart = "";
        this.levelClass = "";
        this.templateElement = [];
        this.state = {
            finalElement: [],
        };
    }

    public componentDidMount() {
        if (window.HTML_RENDITION.initialData.isStaticHtml){
            return;
        }
        const { source } = this.props;
        let result: any = null;
        for (let i = 0; i < source.data.length; i++) {
            const template = [];
            const element = source.data[i];
            const elementData = element.data;
            let elementStyle = "";
            if (this.templateElement.length > 0) {
                this.templateElement = [];
            }
            for (let j = 0; j < elementData.length; j++) {
                const innerElement = elementData[j];
                const innerElementData = innerElement.data;

                if ((!_.isUndefined(innerElementData) && innerElementData.length > 0)) {
                    const text = innerElementData[0].text;
                    innerElementData[0].text = " " + text;
                }

                template.push(
                    <DomTemplate sourceM={innerElement}
                                 dataStringM={'paragraph'}
                                 classNameM={''}
                                 showOriginalText={this.props.showOriginalText}
                                 key={shortid.generate()}/>
                );
            }

            if (element.format) {
                elementStyle = element.format.class;
            }
            this.templateElement.push(
                <li key={shortid.generate()} className={elementStyle}>
                    {template}
                </li>
            );

            if (this.shouldGenerateAccordionListItem(i, source)) {
                this.getListItemTplForAccordions(source);
            }

            this.allListElements.push(this.templateElement);
            this.levelClass = "level-" + element['list-level'];

            if (source.format) {
                if (source.format.class) {
                    this.allListElementClass = source.format.class + ' ' + this.levelClass;
                }

                if (source.format.style) {
                    this.allListElementStyle = source.format.style;
                }

                if (source.format.start) {
                    this.allListElementStart = ' start="' + source.format.start + '" ';
                }
            }

            if (this.allListElements.length) {
                result = (<this.props.source.class key={shortid.generate()}
                                                   className={this.allListElementClass}
                                                   style={StyleTransfrom(this.allListElementStyle)}
                                                   start={this.allListElementStart || {}}>
                    {this.allListElements}
                </this.props.source.class>);
            }

            if (this.shouldCoverWithTable(this.levelClass)) {
                result = (<table className={"x-rsch-table-list-holder"}>
                    <tbody>
                        <tr>
                            <td>
                                {result}
                            </td>
                        </tr>
                    </tbody>
                </table>);
            }

            this.setState({
                finalElement: result
            });
        }
    }

    public shouldComponentUpdate(){
        return !window.HTML_RENDITION.initialData.isStaticHtml;
    }

    public shouldGenerateAccordionListItem(listIndex: number, scope: any) {
        // For mobile, the accordions in abstract section should come after the first bullet and aligned center.
        // This is shown and hidden based on mobile / desktop resolution.
        // 'mainSource' will be passed only in abstract accordions
        return (listIndex === 0
            && !_.isUndefined(scope.mainSource)
            && !scope.mainSource.isAnotherAccordionsForMobileCreated);
    }

    public getListItemTplForAccordions(scope: any) {
        scope.mainSource.isAnotherAccordionsForMobileCreated = true;
        if (HTML_RENDITION.isBlackberryMode()) {
            this.templateElement.push(<BbryAccordionsTemplate
                source={this.props.mainSource.issuerPage.abstract_accordions} classString={""}/>);
        } else {
            this.templateElement.push(<li className="visible-xs">
                <BbryAccordionsTemplate source={this.props.mainSource.issuerPage.abstract_accordions}
                                        classString={"visible-xs"}/>
            </li>);
        }
    }

    // List will be placed inside table in either of these cases
    // 1. All the lists that is not in the abstract bullets area
    // 2. All the lists other than first level in the abstract bullets area
    public shouldCoverWithTable(levelClass: string) {
        const issuerPageHolder = this.props.elementParent === 'issuerPage-abstract-list-container';
        const CompanyFocusHolder = this.props.elementParent === 'companyFocus-abstract-list-container';
        const tdHolder = $('.' + levelClass).parents('td');
        const level = (levelClass.indexOf('-') !== -1) ? levelClass.substring(levelClass.indexOf('-') + 1, levelClass.length) : 1;
        return ((CompanyFocusHolder === false && issuerPageHolder === false) || (level > 1)) && (window.HTML_RENDITION.initialData.isStaticHtml || tdHolder.length == 0);
    }

    public render() {
        if (window.HTML_RENDITION.initialData.isStaticHtml){
            const { source } = this.props;
            let result: any = null;
            for (let i = 0; i < source.data.length; i++) {
                const template = [];
                const element = source.data[i];
                const elementData = element.data;
                let elementStyle = "";
                if (this.templateElement.length > 0) {
                    this.templateElement = [];
                }
                for (let j = 0; j < elementData.length; j++) {
                    const innerElement = elementData[j];
                    const innerElementData = innerElement.data;

                    if ((!_.isUndefined(innerElementData) && innerElementData.length > 0)) {
                        const text = innerElementData[0].text;
                        innerElementData[0].text = text;    // " " + text;
                    }

                    template.push(
                        <DomTemplate sourceM={innerElement}
                                    dataStringM={'paragraph'}
                                    classNameM={''}
                                    key={shortid.generate()}/>
                    );
                }

                if (element.format) {
                    elementStyle = element.format.class;
                }

                this.templateElement.push(
                    <li key={shortid.generate()}
                        className={elementStyle}>{template}
                    </li>
                );

                if (this.shouldGenerateAccordionListItem(i, source)) {
                    this.getListItemTplForAccordions(source);
                }

                this.allListElements.push(this.templateElement);
                this.levelClass = "level-" + element['list-level'];

                if (source.format) {
                    if (source.format.class) {
                        this.allListElementClass = source.format.class + ' ' + this.levelClass;
                    }

                    if (source.format.style) {
                        this.allListElementStyle = source.format.style;
                    }

                    if (source.format.start) {
                        this.allListElementStart = ' start="' + source.format.start + '" ';
                    }
                }

                if (this.allListElements.length) {
                    result = (<this.props.source.class key={shortid.generate()}
                                                    className={this.allListElementClass}
                                                    style={StyleTransfrom(this.allListElementStyle)}
                                                    start={this.allListElementStart || {}}>
                        {this.allListElements}
                    </this.props.source.class>);
                }

                if (this.shouldCoverWithTable(this.levelClass)) {
                    result = (<table className={"x-rsch-table-list-holder"}>
                        <tbody>
                            <tr>
                                <td>
                                    {result}
                                </td>
                            </tr>
                        </tbody>
                    </table>);
                }
            }
            return (
                <React.Fragment>
                    {result}
                </React.Fragment>
            );
        } else {
            return (
                <React.Fragment>
                    {this.state.finalElement}
                </React.Fragment>
            );
        }
    }
}

export default CitiListTemplate;
